module.exports = __webpack_public_path__ + "img/ai.fbe1e1e.png";